import * as React from "react";
import { PropsChecker } from "../../helpers/props-checker/props-checker.mjs";
import { SidemenuNav } from "../sidemenu-nav/sidemenu-nav.mjs";
import { SidemenuContext } from "./sidemenu-context.mjs";
const Sidemenu = (props) => {
  return /* @__PURE__ */ React.createElement(PropsChecker, { componentProps: props, componentName: "Sidemenu", defaultValueName: "defaultTree", valueName: "tree", onChangeNames: "onTreeChange" }, /* @__PURE__ */ React.createElement(SidemenuInner, { ...props }));
};
class SidemenuInner extends React.Component {
  constructor(props) {
    super(props);
    this.handleTreeChange = (tree) => {
      if (typeof this.props.tree === "undefined") {
        this.setState({
          tree
        });
      }
      if (this.props.onTreeChange) {
        this.props.onTreeChange(tree);
      }
    };
    this.setSubContainer = (element) => {
      this.setState({
        subContainer: element
      });
    };
    this.state = {
      subContainer: null,
      tree: props.defaultTree || []
    };
  }
  get tree() {
    return this.props.onTreeChange && typeof this.props.tree !== "undefined" ? this.props.tree : this.state.tree;
  }
  BEM() {
    const classArray = ["sidemenu"];
    if (this.props.style) {
      classArray.push("sidemenu--" + this.props.style);
    }
    if (this.props.color) {
      classArray.push("sidemenu--" + this.props.color);
    }
    if (this.props.className) {
      classArray.push(this.props.className);
    }
    return classArray.join(" ");
  }
  get sidemenuContextValue() {
    var _a;
    return {
      behaviour: (_a = this.props.behaviour) != null ? _a : "list"
    };
  }
  render() {
    return /* @__PURE__ */ React.createElement(SidemenuContext.Provider, { value: this.sidemenuContextValue }, /* @__PURE__ */ React.createElement("nav", { className: this.BEM(), "aria-labelledby": this.props["aria-labelledby"] }, /* @__PURE__ */ React.createElement("div", { className: "sidemenu__main" }, /* @__PURE__ */ React.createElement("div", { className: "sidemenu__view" }, /* @__PURE__ */ React.createElement(
      SidemenuNav,
      {
        tree: this.tree,
        level: 0,
        behaviour: this.props.behaviour,
        onTreeChange: this.handleTreeChange,
        subContainer: this.state.subContainer || void 0,
        elementRef: this.props.elementRef,
        "aria-labelledby": this.props["aria-labelledby"]
      }
    ))), /* @__PURE__ */ React.createElement("div", { className: "sidemenu__sub", ref: this.setSubContainer })));
  }
}
export {
  Sidemenu,
  SidemenuInner
};
